import { useSelector } from 'react-redux';
import {
  FormFieldProps,
  VariantComboFormField,
  VariantComboFormFieldKey,
} from 'modules/experiments/types';
import {
  getTakeoverCampaignMessageMedium,
  getTakeoverExperimentType,
} from 'modules/experiments/ducks/selectors';
import { useTakeoverExperimentContext, useVariantCardContext } from 'modules/experiments/contexts';
import { getDefaultSendTimeFieldValues, getVariantFormFieldValue } from 'modules/experiments/utils';

import { WebPushTitleBody } from './WebPushTitleBody';
import { EmailSender } from './EmailSender';
import { SendTime } from './SendTime';

export const ComboFormField = ({ formField }: FormFieldProps<VariantComboFormField>) => {
  const {
    isSendTimeExperiment,
    sendTimeMetaInfo: { controlStartTime, sendTimeOfAllVariants, sendTimeStartTimeZone },
  } = useTakeoverExperimentContext();
  const { isCardInEditMode, variant } = useVariantCardContext();
  const type = useSelector(getTakeoverExperimentType);
  const messageMedium = useSelector(getTakeoverCampaignMessageMedium);
  const fieldValues = isSendTimeExperiment
    ? getDefaultSendTimeFieldValues({
        variant,
        controlStartTime,
        sendTimeOfAllVariants,
        sendTimeStartTimeZone,
      })
    : getVariantFormFieldValue({ variant, type, messageMedium });

  switch (formField.key) {
    case VariantComboFormFieldKey.WEB_PUSH_TITLE_BODY:
      return (
        <WebPushTitleBody
          formFields={formField.fields}
          fieldValues={fieldValues}
          isFieldEditable={isCardInEditMode}
        />
      );

    case VariantComboFormFieldKey.EMAIL_SENDERS:
      return (
        <EmailSender
          formFields={formField.fields}
          fieldValues={fieldValues}
          isFieldEditable={isCardInEditMode}
        />
      );

    case VariantComboFormFieldKey.SEND_TIME:
      return (
        <SendTime
          formFields={formField.fields}
          fieldValues={fieldValues}
          isFieldEditable={isCardInEditMode}
        />
      );

    default:
      return <></>;
  }
};
